var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.SL=require("moment");module.exports=$CLJS.SL;